import { render } from "./base-button.vue?vue&type=template&id=fdb5ffe4&scoped=true&ts=true"
import script from "./base-button.vue?vue&type=script&lang=ts"
export * from "./base-button.vue?vue&type=script&lang=ts"

import "./base-button.vue?vue&type=style&index=0&id=fdb5ffe4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb5ffe4"]])

export default __exports__